import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useState, useEffect, createContext } from 'react';
const OsContext = createContext(null);
export const OsProvider = ({ children, osContext, osApi }) => {
    const [osContextValue, setOsContextValue] = useState(null);
    useEffect(() => osContext.subscribe(setOsContextValue), [osContext]);
    if (!osContextValue) {
        return null;
    }
    return (_jsx(OsContext.Provider, { value: {
            osContext: osContextValue,
            osApi,
        }, children: children }));
};
export const useOs = () => useContext(OsContext);
